<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="450" scrollable persistent>
			<v-card>
				<v-card-title class="text-h6">Konfirmasi Transfer Pembayaran</v-card-title>
				<v-card-text>
					<v-form ref="formApproval" role="form">
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="status_code" :rules="statusRules" :items="listSelection" item-text="text" item-value="value" label="Status Pembayaran" class="width-0" no-data-text="Tidak ada data tersedia" @focus="() => error_validation.status_code=''" :error-messages="error_validation.status_code"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-textarea outlined dense v-model="note" :rules="noteRules" @focus="() => error_validation.note=''" :error-messages="error_validation.note" label="Catatan"></v-textarea>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapState} from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			statusRules: [
			value => !!value || 'Status tidak boleh kosong',
			],
			noteRules: [
			value => {
				if (!value && this.status_code == 2) {
					return false || 'Catatan tidak boleh kosong'
				}
				return true
			},
			],
			note: '',
			status_code: '',
			listSelection: [{
				value: '',
				text: 'Pilih Status Pembayaran'
			}, {
				value: 2,
				text: 'Pembayaran Ditolak Oleh Admin'
			}, {
				value: 3,
				text: 'Pembayaran Diterima',
			}]
		}
	},
	computed: {
		...mapState(['error_validation']),
	},
	props: {
		listSystem: {
			type: Array
		}
	},
	methods: {

		async showModal() {
			this.status_code = ''
			this.note = ''
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
		},
		batal() {
			this.hideModal()
		},
		simpan() {
			if (this.$refs.formApproval.validate()) {
				let params = {
					status_code: this.status_code,
					note: this.note,
				}
				this.$emit('action', params)
			}
		},
	},
}
</script>
